import { SheetClose } from "@/components/shared/ui/sheet";
import { ShopDeliveryDate, ShopEmailContact } from "@/lib/checkout/checkout-types";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useRouter } from "next/navigation";
import { useRef } from "react";
import MockDialog from "./mock-dialog";

export function CartHeader({
    customerName,
    customerID,
    cartID,
    enableMock,
    mockDefaultValues
}: {
    customerName: string;
    customerID: number;
    cartID: number;
    enableMock: boolean;
    mockDefaultValues?: {
        PONum?: string;
        deliveryDate?: ShopDeliveryDate;
        orderMemo?: string;
        emailNote?: string;
        sendEmail?: boolean;
        contacts?: ShopEmailContact[];
    };
}) {
    const sheetCloseRef = useRef<HTMLButtonElement>(null);
    const router = useRouter();

    const handleDialogSuccess = () => {
        router.push(`/mock-orders/${cartID}`);
        sheetCloseRef.current?.click();
    };

    return (
        <div className="flex items-center justify-between pb-4">
            <div className="flex flex-wrap items-center gap-2">
                <p className="text-lg font-semibold">
                    Cart for ({customerID}) {customerName}
                </p>
                {enableMock && (
                    <MockDialog
                        cartID={cartID}
                        customerID={customerID}
                        onSuccess={handleDialogSuccess}
                        defaultValues={mockDefaultValues}
                    />
                )}
            </div>
            <SheetClose ref={sheetCloseRef} asChild>
                <button className="relative flex h-11 w-11 items-center justify-center rounded-md border border-neutral-200 text-black transition-colors dark:border-neutral-700 dark:text-white">
                    <XMarkIcon />
                </button>
            </SheetClose>
        </div>
    );
}
